"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 6a6 6 0 100 12 6 6 0 000-12zm2.953 4.496h-.914v-.515h-1.582v4.038h.713v.914h-2.34v-.914h.713V9.98H9.962v.515h-.915V9.067h5.906v1.43z" }), "Text");
//# sourceMappingURL=Text.js.map